import bmAxiosClient from "../../GenAPI/axiosClient";

const saveOper = (data) =>  bmAxiosClient.post('/api/opers/save   ', data);

const getOpers = (data) => bmAxiosClient.get('/api/opers', {params: data});        

const deleteOper = (id) => bmAxiosClient.delete('/api/opers/delete', { data:{id: id}});

export default {saveOper, getOpers, deleteOper};
